import { Box, Typography, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ReportDataGrid from '../../../components/Common/ReportDataGrid';
import { formatWeight, formatPercent, exportRowsToCsv } from '../../../components/Common/ReportDataGrid/utils';
import { trakrefBlue } from '../../../color_utils';

const AssetLevelTable = ({ rows, totalEmissionsLbs, totalEmissionsCo2e, loading }) => {
    const columns = [
        {
            field: 'location',
            headerName: 'Location',
        },
        {
            field: 'assetName',
            headerName: 'Asset Name',
        },
        {
            field: 'assetId',
            headerName: 'Asset ID',
        },
        {
            field: 'assetStatus',
            headerName: 'Asset Status',
        },
        {
            field: 'operationalStatus',
            headerName: 'Operational Status',
        },
        {
            field: 'assetType',
            headerName: 'Asset Type',
        },
        {
            field: 'materialType',
            headerName: 'Material Type',
        },
        {
            field: 'chargecapacityLbs',
            headerName: 'Charge Capacity (lbs)',
            type: 'number',
            valueFormatter: formatWeight,
        },
        {
            field: 'calendarYearLeakRate',
            headerName: 'Calendar Year Leak Rate',
            type: 'number',
            valueFormatter: formatPercent(0),
        },
        {
            field: 'emissionsLbs',
            headerName: 'Emissions (lbs)',
            type: 'number',
            valueFormatter: formatWeight,
        },
        {
            field: 'netGasAddedLbs',
            headerName: 'Net Gas Added (lbs)',
            type: 'number',
            valueFormatter: formatWeight,
        },
        {
            field: 'gwp',
            headerName: 'GWP',
            type: 'number',
        },
        {
            field: 'emissionsCo2e',
            headerName: 'Emissions (lbs CO2e)',
            type: 'number',
            valueFormatter: formatWeight,
        },
    ];

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                        Asset-Level Emissions (Annual Leak Activity)
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Refrigerant Leakage/Fugitive Emissions by Asset
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<DownloadIcon />}
                    onClick={() => exportRowsToCsv(columns, rows, 'asset_level_emissions.csv')}
                    sx={{ backgroundColor: trakrefBlue, '&:hover': { backgroundColor: trakrefBlue }, flexShrink: 0 }}
                    disabled={rows.length === 0}
                >
                    Export CSV
                </Button>
            </Box>
            <ReportDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={(row) => row.assetId}
                noRowsLabel="No assets found. Try adjusting your filters."
            />
            {rows.length > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, gap: 4, pr: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        Total Emissions: {Math.round(totalEmissionsLbs).toLocaleString()} lbs
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        Total Emissions: {Math.round(totalEmissionsCo2e).toLocaleString()} lbs CO2e
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default AssetLevelTable;
